import { IconButton, TextField, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { Formik, Form, ErrorMessage, Field } from 'formik';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { BiEdit } from 'react-icons/bi';
import { DataGrid, GridDeleteForeverIcon } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import {
  deleteNotification,
  getNotifications,
  postNotification,
  updateNotification,
} from '../../features/notifications/notificaitonSlice';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import dayjs from 'dayjs';

const Notifications = () => {
  const { userDetails } = useSelector((state) => state.auth?.successData);
  const [notices, setNotices] = useState([]);
  const [noticeData, setNoticeData] = useState();
  async function getNotices() {
    const response = await dispatch(getNotifications()).unwrap();
    setNotices(response);
  }
  useEffect(() => {
    getNotices();
  }, []);
  const columns = [
    {
      field: 'message',
      renderCell: (params) => (
        <p className='truncate px-2' style={{ fontSize: '16px' }}>
          {params.value}
        </p>
      ),
      headerName: (
        <Typography variant='body1' className='pl-4  text-blue-500 font-bold'>
          Notifications
        </Typography>
      ),
      flex: 1,
      sortable: false,
    },
    {
      field: 'eventDate',
      headerAlign: 'center',
      headerName: (
        <Typography variant='body1' className='text-center container font-bold'>
          Date
        </Typography>
      ),
      minwidth: '130px',
      flex: 0.3,
      renderCell: (params) => (
        <p className='text-center'>
          {dayjs(params.value).format('DD-MM-YYYY')}
        </p>
      ),
    },
    {
      field: 'Actions',
      headerAlign: 'center',
      headerName: (
        <Typography variant='body1' className='font-bold'>
          Action
        </Typography>
      ),
      minwidth: '100px',
      flex: 0.3,
      renderCell: (params) => (
        <div className='flex py-2 gap-2 justify-center'>
          <IconButton
            size='small'
            className='text-blue-500 bg-blue-100 rounded'
            variant='outlined'
            onClick={() => {
              setNoticeData(params.row);
            }}
          >
            <BiEdit />
          </IconButton>

          <IconButton
            size='small'
            className='text-red-400 bg-red-100 rounded'
            variant='outlined'
            onClick={async () => {
              const result = await dispatch(
                deleteNotification(params.row.id),
              ).unwrap();
              if (!result) {
                alert('Error in Deletion');
              } else {
                getNotices();
              }
            }}
          >
            <GridDeleteForeverIcon />
          </IconButton>
        </div>
      ),
      sortable: false,
    },
  ];
  const dispatch = useDispatch();
  return (
    <>
      <div className=' mt-3 p-3 py-2 bg-[#eef0f7]  rounded-lg  '>
        <Formik
          enableReinitialize
          initialValues={
            noticeData || {
              id: '',
              message: '',
              eventDate: '',
            }
          }
          validationSchema={Yup.object({
            message: Yup.string()
              .required(' Enter Message')
              .max(250, 'Message must be at most 250 characters'),
            eventDate: Yup.date()
              .required('Enter  EventDate or Date of last Day to Visible')
              .min(
                (() => {
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);
                  return today;
                })(),
                'Event Date cannot be in the past',
              ),
          })}
          onSubmit={async (values, { resetForm }) => {
            if (values.id) {
              const status = await dispatch(
                updateNotification({
                  ...values,
                  createdBy: userDetails.userName,
                }),
              ).unwrap();
              if (status === 200) {
                resetForm();
                setNoticeData(null);
                getNotices();
              } else alert('Something went wrong,Please try Again.');
            } else {
              const response = await dispatch(
                postNotification({
                  message: values.message,
                  eventDate: values.eventDate,
                  createdBy: userDetails.userName,
                }),
              ).unwrap();
              if (response === 200) {
                resetForm();
                setNoticeData(null);
                getNotices();
              } else alert('Something went wrong,Please try Again.');
            }
          }}
        >
          {({ values }) => (
            <Form>
              <div className='flex flex-col   '>
                <h4 className='mb-2 text-blue-600'>
                  Post any Notifications Here !
                </h4>
                <div className='flex flex-col sm:flex-row mt-2 sm:items-end   '>
                  <div className='w-full max-w-80 '>
                    <style>
                      {`
                     .react-datepicker__navigation {
  display: none !important;}

    .react-datepicker__current-month {
          display: none !important;
        }`}
                    </style>
                    <Field name='eventDate'>
                      {({ field, form }) => (
                        <DatePicker
                          selected={field.value ? new Date(field.value) : null}
                          onChange={(val) => {
                            if (val instanceof Date && !isNaN(val)) {
                              // Fix timezone offset issue by subtracting the timezone offset in ms
                              const correctedDate = new Date(
                                val.getTime() - val.getTimezoneOffset() * 60000,
                              );
                              form.setFieldValue(
                                field.name,
                                correctedDate.toISOString().split('T')[0],
                              );
                            } else {
                              form.setFieldValue(field.name, null);
                            }
                          }}
                          onCalendarClose={() =>
                            setTimeout(() => {
                              form.setFieldTouched(field.name, true, true);
                            }, 0)
                          }
                          placeholderText='DD-MM-YYYY'
                          dateFormat='dd/MM/yyyy'
                          isClearable={!!field.value}
                          showMonthDropdown
                          showYearDropdown
                          scrollableYearDropdown
                          yearDropdownItemNumber={51} // 1980 → 2030 inclusive
                          dropdownMode='scroll'
                          minDate={new Date(1980, 0, 1)}
                          maxDate={new Date(2050, 11, 31)}
                          wrapperClassName='w-full bg-white'
                          autoComplete='off'
                          customInput={
                            <TextField
                              fullWidth
                              label='Event Date'
                              size='small'
                              InputLabelProps={{ shrink: true }}
                            />
                          }
                        />
                      )}
                    </Field>
                  </div>
                  <ErrorMessage
                    name='eventDate'
                    component='div'
                    className='text-red-500 ml-4'
                  ></ErrorMessage>
                </div>
                <Field
                  as={TextField}
                  name='message'
                  multiline
                  rows={3}
                  InputLabelProps={{ shrink: true }}
                  label='Notification msg'
                  placeholder='Enter Your Text Here'
                  className='bg-white mt-2'
                ></Field>
                <div className='md:flex md:flex-row'>
                  <ErrorMessage
                    name='message'
                    component='div'
                    className='text-red-500'
                  ></ErrorMessage>
                  <button
                    type='submit'
                    disabled={!(!!values.message && !!values.eventDate)}
                    className={`bg-blue-600 text-white rounded-md w-[8.8rem]  py-2 ml-auto mt-1 
                     ${!(!!values.message && !!values.eventDate) ? 'bg-gray-300  cursor-not-allowed' : ''}`}
                  >
                    {' '}
                    Save{' '}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <div className='overflow-auto'>
        <div className='rounded-lg mt-2 h-auto min-w-[610px]'>
          <DataGrid
            sx={{
              maxHeight: '70vh',
              '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                outline: 'none',
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: '#ffffff',
                },
              },
              ' .MuiDataGrid-columnHeader': {
                backgroundColor: '#f9faff',
                position: 'sticky',
                top: 0,
                zIndex: 10,
              },
              '.MuiDataGrid-virtualScroller': {
                maxHeight: 'calc(70vh - 120px)',
                overflow: 'auto',
              },
            }}
            rows={(notices || [])
              .slice()
              .sort((a, b) => new Date(a?.eventDate) - new Date(b?.eventDate))}
            columns={columns}
            hideFooter={true}
            disableColumnMenu
            // getRowClassName={(params) =>
            //   params.row.id === (notices.length > 0 ? notices[0].id : [])
            //     ? 'bg-gray-100 font-semibold'
            //     : ''
            // }
          />
        </div>
      </div>
    </>
  );
};
export default Notifications;
